module.exports = __webpack_public_path__ + "static/media/formSeachIcon.9a7abfd0.svg";